import { USER_SELECTED_LANG_COOKIE } from '@constants'
import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

type Translations = Record<string, string>
type LocalUnion = 'enUS' | 'zhTW' | 'zhHK'

// TODO implement factory to create translations
export class DniI18n {
  locales: Record<LocalUnion, Translations>
  static user_lang: string
  static lastLocales: Record<LocalUnion, Translations> = {
    enUS: {},
    zhHK: {},
    zhTW: {},
  }

  constructor(locales: Record<LocalUnion, Translations>) {
    this.locales = locales
    DniI18n.lastLocales = {
      enUS: { ...DniI18n.lastLocales.enUS, ...locales.enUS },
      zhHK: { ...DniI18n.lastLocales.zhHK, ...locales.zhHK },
      zhTW: { ...DniI18n.lastLocales.zhTW, ...locales.zhTW },
    }
  }

  init() {
    i18next.init(this.getI18nConfig())
  }

  useInit() {
    i18next.use(initReactI18next).init(this.getI18nConfig())
  }

  // NOTE: 字串表 match ${index}，如有新的翻譯請優先使用 translateV2，未來需將所有替換成 translateV2
  static translate(key: string, ...variables: (string | number)[]) {
    try {
      if (!i18next.exists(key)) {
        return key
      }

      const translation = i18next.t(key)

      // 變數數量不對時直接回傳翻譯字串
      const placeholderCount = (translation.match(/\$\d+/g) || []).length
      if (placeholderCount !== variables.length) {
        console.warn(
          `警告：${key} 需要 ${placeholderCount} 個變數，但提供了 ${variables.length} 個。`,
        )

        return translation
      }

      // 替換字串中的 $1, $2, $3 佔位符
      let formattedString = translation
      variables.forEach((variable, index) => {
        formattedString = formattedString.replace(`$${index + 1}`, variable.toString())
      })

      return formattedString
    }
    catch {
      return key
    }
  }

  // NOTE: 字串表 match %{index}$s
  static translateV2(key: string, ...variables: (string | number)[]) {
    try {
      if (!i18next.exists(key)) {
        return key
      }

      const translation = i18next.t(key)
      const placeholderCount = (translation.match(/%\d+\$s/g) || []).length

      if (placeholderCount !== variables.length) {
        console.warn(
          `警告：${key} 需要 ${placeholderCount} 個變數，但提供了 ${variables.length} 個。`,
        )
        return translation
      }

      let formattedString = translation
      variables.forEach((variable, index) => {
        formattedString = formattedString.replace(`%${index + 1}$s`, variable.toString())
      })

      return formattedString
    }
    catch {
      return key
    }
  }

  getI18nConfig() {
    const allowedLangs = ['en_US', 'zh_TW', 'zh_HK']
    const urlPath = window.location.pathname
    // TODO the path to the language mapping should from backend.
    const defaultLang
      = urlPath.includes('/us/') || urlPath.includes('/sg/') || urlPath.includes('/my/')
        ? 'en_US'
        : urlPath.includes('/hk/')
          ? 'zh_HK'
          : 'zh_TW'
    console.debug('[Locale] defaultLang=', defaultLang)
    const match = document.cookie.match(
      `(^|;)\\s*${USER_SELECTED_LANG_COOKIE}\\s*=\\s*([^;]+)`,
    )
    // @ts-expect-error - TODO: fix this
    const userSelectedLang: string = match !== null ? match[2] : ''
    const calculatedLang: string = allowedLangs.includes(userSelectedLang)
      ? userSelectedLang
      : defaultLang
    // Todo Note this integrated with the i18next library
    DniI18n.user_lang = calculatedLang
    return {
      resources: {
        en_US: {
          translation: DniI18n.lastLocales?.enUS || {},
        },
        zh_TW: {
          translation: DniI18n.lastLocales?.zhTW || {},
        },
        zh_HK: {
          translation: DniI18n.lastLocales?.zhHK || {},
        },
      },
      lng: calculatedLang,
      fallbackLng: defaultLang,
      interpolation: {
        escapeValue: false,
      },
      nsSeparator: 'false',
    }
  }
}
